/**
 *
 * LeadersSummary
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import check from "images/check.svg"
import questionIcon from "images/question.svg"

import SummaryScreen from "components/SummaryScreen"
import Loader from "components/Loader"
import { pick, get } from "lodash"
import { Modal, Button, Progress, Checkbox, Popover } from "antd"
import saga from "./saga"
import reducer from "./reducer"
import {
  getLeadersSummaryWatcher,
  uploadTemplateLeadersWatcher,
  saveExcelLeadersWatcher,
} from "./actions"
import {
  makeSelectSummary,
  makeSelectIsLoadingSummary,
  makeSelectPercentage,
} from "./selectors"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
export class LeadersSummary extends React.Component {
  state = {
    modalProgress: false,
    invitate: true,
  }

  UNSAFE_componentWillMount = () => {
    this.props.getLeadersSummaryWatcher()
  }

  setChangeModal = (name, value) => {
    this.setState({ [name]: value })
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Líderes - Activación</title>
          <meta name="description" content="Description of LeadersSummary" />
        </Helmet>
        {this.props.isLoadingSummary ? (
          <Loader />
        ) : (
          <div className="LeadersSummary-screen">
            <SummaryScreen
              typeImport="Activación"
              gridHeader="160px 120px 220px 100px 1.5fr"
              header={[
                "Nombre",
                "Apellido",
                "Correo electrónico",
                "Usuario líder",
                "Error",
              ]}
              gridContent="160px 120px 220px 100px 1.5fr"
              content={[
                "firstName",
                "lastName",
                "email",
                "user_leader",
                "messsage",
              ]}
              disabledButton={()=> false}
              uploadTemplate={this.props.uploadTemplateLeadersWatcher}
              onFinalize={(params) => {
                this.setChangeModal("modalProgress", true)
                params.invitate = this.state.invitate
                this.props.saveExcelLeadersWatcher(params)
              }}
              maxWidthTable="90%"
              textResume={{
                text: "líder",
                success: (
                  <React.Fragment>
                    <span>
                      {`${get(this.props.summary, "count_import", 0)} `}
                    </span>
                    {`${plural(
                      "líder",
                      get(this.props.summary, "count_import", 0),
                      "es"
                    )} ${plural(
                      "activado",
                      get(this.props.summary, "count_import", 0),
                      "s"
                    )}`}
                  </React.Fragment>
                ),
                failed: (
                  <React.Fragment>
                    <span>
                      {`${get(this.props.summary, "count_error", 0)} `}
                    </span>
                    {`${plural(
                      "líder",
                      get(this.props.summary, "count_error", 0),
                      "es"
                    )} sin activar`}
                  </React.Fragment>
                ),
              }}
              hasUpdates={false}
              history={this.props.history}
              urlBack="/control-panel#user-management"
              title="líderes"
              backTitle="Gestión de usuarios"
              modalImportAgainTitle="¿Estás seguro de que deseas realizar una nueva activación?"
              backModalTitle="¿Estás seguro de que deseas salir de la activación?"
              modalFinalizeWidth={440}
              modalFinalize={
                <React.Fragment>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>
                    ¿Estás seguro de que deseas finalizar la activación de{" "}
                    <br /> líderes?
                  </span>
                  <p style={{ fontSize: 13, marginTop: 8 }}>
                    Esta acción les dará <b>acceso</b> a la plataforma y les
                    permitirá <br />
                    visualizar sus <b>resultados</b> de liderazgo una vez
                    habilitados.
                  </p>
                  <div style={{ textAlign: "left", display: "flex" }}>
                    <Checkbox
                      checked={this.state.invitate}
                      onChange={(e) =>
                        this.setState({ invitate: e.target.checked })
                      }>
                      Enviar correo de invitación al sistema.
                    </Checkbox>
                    <Popover
                      placement="top"
                      content={
                        <div>
                          Los líderes recibirán un{" "}
                          <b>
                            correo de <br /> invitación
                          </b>{" "}
                          al sistema al ser asignados
                        </div>
                      }>
                      <img src={questionIcon} alt="question-icon" />
                    </Popover>
                  </div>
                </React.Fragment>
              }
              {...pick(this.props.summary, [
                "count_import",
                "count_error",
                "listErrors",
                "invitate",
              ])}
            />
          </div>
        )}

        <Modal
          visible={this.state.modalProgress}
          okText="Aceptar"
          closable={false}
          footer={
            this.props.percentage !== 100
              ? null
              : [
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      this.setChangeModal("modalProgress", false)
                      this.props.history.push("/control-panel#user-management")
                    }}>
                    Aceptar
                  </Button>,
                ]
          }
          width={520}>
          {this.props.percentage !== 100 ? (
            <div className="modalSuccess">
              <Progress
                style={{ margin: "0 auto" }}
                width={80}
                type="circle"
                percent={this.props.percentage}
              />
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                La activación puede tardar unos minutos...
              </span>
            </div>
          ) : (
            <div className="modalSuccess" style={{ textAlign: "center" }}>
              <img src={check} />
              <span
                style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
                Los líderes han sido activados como usuarios.
              </span>
            </div>
          )}
        </Modal>
      </React.Fragment>
    )
  }
}

LeadersSummary.propTypes = {
  getLeadersSummaryWatcher: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  summary: makeSelectSummary(),
  isLoadingSummary: makeSelectIsLoadingSummary(),
  percentage: makeSelectPercentage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getLeadersSummaryWatcher: () => dispatch(getLeadersSummaryWatcher()),
    uploadTemplateLeadersWatcher: (params) =>
      dispatch(uploadTemplateLeadersWatcher(params)),
    saveExcelLeadersWatcher: (params) =>
      dispatch(saveExcelLeadersWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "leadersSummary", reducer })
const withSaga = injectSaga({ key: "leadersSummary", saga })

export default compose(withReducer, withSaga, withConnect)(LeadersSummary)
